import * as EducationExternals from './externals';

export const ReducerKeys = {
  PREMIUM_ACCESS_EDUCATION_WELCOME_MESSAGE_COUNT: 'premiumAccessEducationWelcomeMessageCount',
  PREMIUM_ACCESS_EDUCATION_EXIT_MESSAGE_COUNT: 'premiumAccessEducationExitMessageCount',
  WATCH_FOR_MTUP_PLAYLIST_UNLOCK: 'WATCH_FOR_MTUP_PLAYLIST_UNLOCK',
  MTUP_PLAYLIST_READY_FOR_MINICOACHMARK: 'MTUP_PLAYLIST_READY_FOR_MINICOACHMARK',
  PODCAST_POSITIVE_FEEDBACK_COUNT: 'podcastPositiveFeedbackCount',
  LISTENERS: EducationExternals.ReducerKeys.LISTENERS,
  SHOW_COUNT: EducationExternals.ReducerKeys.SHOW_COUNT,
};

export const ActionKeys = {
  INCREMENT_PREMIUM_ACCESS_EDUCATION_WELCOME_MESSAGE_COUNT:
    'INCREMENT_PREMIUM_ACCESS_EDUCATION_WELCOME_MESSAGE_COUNT',
  INCREMENT_PREMIUM_ACCESS_EDUCATION_EXIT_MESSAGE_COUNT:
    'INCREMENT_PREMIUM_ACCESS_EDUCATION_EXIT_MESSAGE_COUNT',
  UPDATE_WATCH_FOR_MTUP_UNLOCK: 'UPDATE_WATCH_FOR_MTUP_UNLOCK',
  UPDATE_MTUP_PLAYLIST_READY_FOR_MINICOACHMARK: 'UPDATE_MTUP_PLAYLIST_READY_FOR_MINICOACHMARK',
};

// todo WEBCLIENT-9692
export const PremiumAccessEducationConstants = {
  PREMIUM_ACCESS_FTUX_EXIT_MESSAGE_URL:
    'https://pandora.com/static/creatives/valueExchange/FTUX/audio/Pandora_PAFTUX_IACS-1700_Script2_V2.mp3',
  PREMIUM_ACCESS_EDUCATION_EXIT_MESSAGE_LIMIT: 1,
};

export const AntiAdBlockerEducationConstants = {
  HAMMER_MODE: 'https://pandora.com/static/creatives/Blocker/Anti-Blocker-Hammer.mp3',
};

export const SourceTypeConstants = {
  FTUX_WELCOME_TONE: 'ftux_welcome_tone',
  FTUX_WELCOME_MESSAGE: 'ftux_welcome_message',
};

export const MAX_PODCAST_POSITIVE_FEEDBACK_COUNT =
  EducationExternals.MAX_PODCAST_POSITIVE_FEEDBACK_COUNT;
